import { useEffect } from "react";

/**
 * Global listeners registry
 */
let listeners = [];
const WS_ENABLED = false;
/**
 * Hook for subscribing to websocket messages
 */
export const useWebSocketListener = (callback) => {
  useEffect(() => {
    listeners.push(callback);
    return () => {
      listeners = listeners.filter((l) => l !== callback);
    };
  }, [callback]);
};

/**
 * Initialize authenticated websocket connection
 */
export const initializeWebSocket = (
  userId,
  token,
  socketRef,
  logOut,
  showAnotherSignInModal,
  onClose
) => {





  

  //disable websocket

if (!WS_ENABLED) {
  socketRef.current = null;
  return;
}







  // Prevent duplicate / unstable connections
  if (
    socketRef.current &&
    (socketRef.current.readyState === WebSocket.CONNECTING ||
      socketRef.current.readyState === WebSocket.OPEN)
  ) {
    return;
  }

  if (!userId || !token) return;

  let pingInterval = null;

  try {


    const ws = new WebSocket(
      `wss://ws.textalk.city:9501?user_id=${encodeURIComponent(userId)}&token=${encodeURIComponent(token)}`,
      "no-deflate"
    );


    ws.isAlive = false;
    socketRef.current = ws;

    // --------------------------------------------------
    // OPEN
    // --------------------------------------------------
    ws.onopen = () => {
      ws.isAlive = true;

      pingInterval = setInterval(() => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(JSON.stringify({ type: "ping" }));
        }
      }, 25000);
    };

    // --------------------------------------------------
    // MESSAGE
    // --------------------------------------------------
    ws.onmessage = (event) => {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch {
        return;
      }
      if (data.type === "pong") {
        ws.isAlive = true;
        return;
      }

      // Server-mandated control messages
      if (data.type === "FORCE_LOGOUT") {
        ws.close(4001, "Forced logout");
        logOut();
        return;
      }

      if (data.type === "another_signIn") {
        ws.close(4002, "Another sign-in detected");
        logOut();
        showAnotherSignInModal(true);
        return;
      }

      // Forward to listeners
      listeners.forEach((l) => l(data));
    };

    // --------------------------------------------------
    // CLOSE
    // --------------------------------------------------
    ws.onclose = () => {
      clearInterval(pingInterval);
      socketRef.current = null;
      onClose?.();
    };

    // --------------------------------------------------
    // ERROR
    // --------------------------------------------------
    ws.onerror = (e) => {
      console.error("WebSocket error:", e);
    };


  } catch (err) {
    console.error("WebSocket initialization failed:", err);
    socketRef.current = null;
  }
};

/**
 * Manual close helper
 */
export const closeWebSocket = (socketRef, reason = "Manual close") => {
  if (socketRef.current) {
    socketRef.current.close(1000, reason);
    socketRef.current = null;
  }
};
